import JsCookie from "js-cookie";
export const getToken = () => {
  return JsCookie.get("token");
};
export const getSaasToken = () => {
  return JsCookie.get("LEAPIN-EXTERNAL-UNFOLDS-TOKEN");
};
export const setSaasToken = (token) => {
  return JsCookie.set("LEAPIN-EXTERNAL-UNFOLDS-TOKEN", token);
};